import {useGTMDispatch} from './react-gtm-hook/index'
import {transformAlgoliaItemsForGA4} from './utils'
import {useRapidDeliveryStore} from '../store/hooks/useStore'

export const useItemDataTracking = () => {
  const sendDataToGTM = useGTMDispatch();
  const rapidStore = useRapidDeliveryStore();
  const sendItemData = (item, badges) => {
    setTimeout(() => {
      try {
        const transformAlgoliaData = {
          items: [item],
          hitItemIndex: null,
          trackingData: {badges},
          isRapidDeliveryBooked: rapidStore.isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForGA4(transformAlgoliaData)
        const currentPrice = item?.displayPrice || item?.price?.GBP || 0
        const eventData = {
          event: 'view_item',
          ecommerce: {
            currency: 'GBP',
            value: currentPrice * _items[0].quantity,
            items: _items
        },
      }
        sendDataToGTM(eventData)  
      } catch (error) {
        console.error('useItemDataTracking error within setTimeout: ' + error.message)
      }
    }, 0);
  };
  return sendItemData;
};